import { createSlice } from "@reduxjs/toolkit";
import { addProductToCart } from "@store/slices/cartSlice/actions/addProductToCart";

export type CartMiniSliceState = {
  opened: boolean;
  interacted: boolean;
  lastAddedProductSku: string;
};

const initialState: CartMiniSliceState = {
  opened: false,
  interacted: false,
  lastAddedProductSku: "",
};

export const cartMiniSlice = createSlice({
  name: "cartMini",
  initialState,
  reducers: {
    open(state) {
      console.log("cartMiniSlice: open action dispatched");
      state.opened = true;
      state.interacted = true;
    },
    close(state) {
      state.opened = false;
      state.interacted = false;
    },
    interact(state) {
      state.interacted = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addProductToCart.fulfilled, (state, action) => {
      state.opened = true;
      state.interacted = false;
      state.lastAddedProductSku = action.meta.arg.sku;
    });
  },
});
